import ChatInbox from '../components/chat/Inbox';

export default function ChatPage() {
  return <ChatInbox />;
}
